module.exports = __webpack_public_path__ + "acorn-search.cc989d9500c9d31c53360fa3a8b2890b.svg";